import {
    // FILE_UPLOAD,
    CREATE_CQCPROVIDERS,
    RETRIEVE_CQCPROVIDERS,
    RETRIEVESINGLE_CQCPROVIDERS,
    UPDATE_CQCPROVIDERS,
    DELETE_CQCPROVIDERS,
} from "./type";
import Providers from "../service/Providers";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await Providers.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await Providers.create(data);
        dispatch({
            type: CREATE_CQCPROVIDERS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await Providers.fetchList(data);
        dispatch({
            type: RETRIEVE_CQCPROVIDERS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await Providers.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_CQCPROVIDERS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveChangedProviders = (data) => async (dispatch) => {
    try {
        const res = await Providers.fetchChangedProviderList(data);
        // dispatch({
        //     type: RETRIEVESINGLE_CQCPROVIDERS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await Providers.update(data);
        dispatch({
            type: UPDATE_CQCPROVIDERS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await Providers.changeStatus(data);
//         dispatch({
//             type: UPDATE_CQCPROVIDERS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await Providers.trash(data);
        dispatch({
            type: DELETE_CQCPROVIDERS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};